import React, { useState } from "react";
import {
    DatePicker,
    Form,
    Modal,
    Popover,
    Select,
    message,
    Input,
    Pagination,
  } from "antd";

import { useSelector, useDispatch } from "react-redux";
import { Radio } from "antd";
import { useEffect } from "react";
import Spinner from "react-bootstrap/Spinner";
import { ADMIN_USER, USER_DATA } from "../../../constants/const";
import { getFromLocalStorage } from "../../../Helpers/localStorageHelper";
import moment from "moment";
import { createTimeSlots } from "../../../Helpers/DateHelpers";
import { createDropdownValues } from "../../../Helpers/helperFunctions";
import Assets from "../../Layout/Assets";
import {
  FETCH_ADMIN_DASHBOARD_REPORT,
  fetch_doctors_list,
  acceptrejectrequest,
  FETCH_REQUEST_DASHBOARD_REPORT
} from "../../../actions/ClinicAdminAction";
import { AssetStore } from "../../../assets/AssetsStore";
import styles from "../../InterbranchAdminComponents/RequestedAppointments/index.module.scss";
import { color } from "@mui/system";
const RadioGroup = Radio.Group;

function AcceptRejectModal({
    open,
    togggle,
    isReassign,
    reAssignData,
    setReassignData,
    appointmentData,
    setProcessdone,
  }) {
    let [timeSlots, setTimeSlots] = useState();
    const [form] = Form.useForm();
    let [doctors, setDoctors] = useState();
    const dispatch = useDispatch();
    const [userId, setUserId] = useState();
    const [isdisabled, setIsdisabled] = useState(false);
    const [isProcessing, setisProcessing] = useState(false);

    useEffect(() => {
      checUser();
      console.log("requestedData", appointmentData);
     
      if (isReassign && reAssignData) {
        form.setFieldsValue({
          appointmentDate: moment(reAssignData?.date),
          appointmentTime: "09:00 am",
          doctorName: doctors,
        });
      }
    }, [open]);
  
    useEffect(() => {
      if (!open) {
        form.resetFields();
      }
    }, [open]);
  
    let checUser = async () => {
      getFromLocalStorage(USER_DATA).then((res) => {
        setUserId(JSON.parse(res).userId);
      });
    };
    const getdoctorslis = () => {
      let doctorslist = [];
      if (doctors != undefined && doctors.length > 0) {
        doctors.map((eachAppointment, key) => {
          doctorslist.push({
            value: eachAppointment.doctorName,
            option: eachAppointment.doctorId,
          });
        });
      }
      return doctorslist;
    };
  
    const getConditionalText = (key) => {
      switch (key) {
        case "formCaption":
          return isReassign ? "Select" : "Confirm";
        case "submitText":
          return isReassign ? "Reassign" : "Assign";
        case "proceessing":
          return "Please wait..";
        case "successMessage":
          return isReassign ? "Reassigned" : "Assigned";
        default:
          break;
      }
    };
  
    function handleAppointmentDateChange(e) {
      console.log("e", e);
      if (e != null) {
        let _timeSlots = createTimeSlots(e);
        setTimeSlots(_timeSlots);
      } else {
        setTimeSlots([]);
      }
    }
  
    function handleFormFinish(data) {
      //togggle(false);
      setIsdisabled(true);
      setisProcessing(true)
      console.log("data", data);
      const momentObject = moment(data.appointmentDate, "DD-MMM-YYYY");
      console.log(
        "momentObject",
        momentObject.format("DD-MMM-YYYY") + " " + data.appointmentTime
      );
      console.log("appointmentData", appointmentData.appointmentRequestId);
  
      let param = {
        process: "accept",
        appointmentId: appointmentData.appointmentRequestId,
        UserId: userId,
        doctorId: userId,
        alternateDate:
          momentObject.format("DD-MMM-YYYY") + " " + data.appointmentTime,
      };
  
      dispatch(acceptrejectrequest(param)).then((res) => {
        console.log("res", res);
        if (
          res.info ===
          "Time slot already choosen by some other person. Please try with different slot, Sorry for the inconvenience."
        ) {
          setIsdisabled(false);
          message.success(
            `Time slot already chosen by some other person. Please try with different slot, Sorry for the inconvenience.`
          );
        } else {
          setIsdisabled(false);
          message.success(
            `Appointment ${getConditionalText("successMessage")} successfully`
          );
          togggle(false);
          setProcessdone(true);
        }
      });
    }
    const { Option } = Select;
  
    return (
      <Modal
        className={`${styles.customModal} ${styles.customModalAccept}`}
        footer={false}
        closeIcon={<></>}
        header={null}
        open={open}
      >
        <Form
          form={form}
          onFinish={handleFormFinish}
          className={styles.accept_form}
        >
          <div className={styles.modalBody}>
            <div className={styles.formItem}>
              <div className={styles.formItemcaption}>
                {getConditionalText("formCaption")} the appointment date{" "}
                <span className={styles.mandatory}>*</span>
              </div>
              <div className={styles.formItemContent}>
                <Form.Item
                  name="appointmentDate"
                  rules={[
                    {
                      required: true,
                      message: "*Please Select Date",
                    },
                  ]}
                >
                  <DatePicker
                    format="DD-MMM-YYYY"
                    disabledDate={(current) =>
                      current.isBefore(moment().subtract(1, "day"))
                    }
                    onChange={handleAppointmentDateChange}
                  />
                </Form.Item>
              </div>
            </div>
  
            <div className={styles.formItem}>
              <div className={styles.formItemcaption}>
                {getConditionalText("formCaption")} the appointment time{" "}
                <span className={styles.mandatory}>*</span>
              </div>
              <div className={styles.formItemContent}>
                <Form.Item
                  name="appointmentTime"
                  rules={[
                    {
                      required: true,
                      message: "*Please Select Time",
                    },
                  ]}
                >
                  <Select
                    options={createDropdownValues(timeSlots)}
                    allowClear
                    placeholder="Select time"
                  />
                </Form.Item>
              </div>
            </div>
  
            {/* <div className={styles.formItem}>
              <div className={styles.formItemcaption}>
                {getConditionalText("formCaption")} the doctor{" "}
                <span className={styles.mandatory}>*</span>
              </div>
              <div className={styles.formItemContent}>
                <Form.Item
                  name="doctorName"
                  rules={[
                    {
                      required: true,
                      message: "*Please Select Doctor",
                    },
                  ]}
                >
                  
                  <Select placeholder="Select Doctor">
                    {doctors != undefined &&
                      doctors.map((option) => (
                        <Option key={option.doctorId} value={option.doctorId}>
                          {option.doctorName}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </div>
            </div> */}
          </div>
  
          <div className={styles.modalFooter}>
            <button
              type="button"
              className={styles.closeModalBtn}
              onClick={() => {
                togggle(false);
              }}
            >
              Close
            </button>
            <button type="submit" className={styles.acceptModalBtn} disabled={isdisabled}>
              {getConditionalText("submitText")}
            </button>
          </div>
        </Form>
      </Modal>
    );
}
export default AcceptRejectModal;